import { personasServices } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/services/personas.service';
import { personasRepositoryInstance } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/instances/personasRepository';
import { PatientDeal } from '../../../ts';
import { createGetPatientsExtraInfoService } from '../create-get-patients-extra-info.service';

const fetchFunction = personasServices(personasRepositoryInstance).getAllPatientDeals;

export const getPatientsDealsService =
  createGetPatientsExtraInfoService<PatientDeal>(fetchFunction);
